/* eslint-disable react/jsx-wrap-multilines */
import React from 'react';
import { Grid } from 'semantic-ui-react';
import './styles.less';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import { FormInputField } from '../../../../../semantic-ui/components/form-input-field';
import { FormSelect } from '../../../../../semantic-ui/components/form-select';
import { FormDoublePhoneField } from '../../../../../semantic-ui/components/form-double-phone-field';
import { normalizePhone } from '../../../../request-modal/utils';

export const LegalFormView = ({
	legalsOptions,
	isLegalsLoading,
	onLegalSearchChange,
	onLegalChange,
	legalsSearchValue,
}) => {
	return (
		<Grid className="legal-form" columns={2}>
			<Grid.Row className="legal-form__row legal-form__row-title">
				<Grid.Column width={16}>
					<h3 className="legal-form__title">Компания</h3>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="legal-form__row legal-form__row-pb-0">
				<Grid.Column width={5} className="legal-form__column">
					<span className="legal-form__column_text-bold">Справочник</span>
				</Grid.Column>
				<Grid.Column width={8} className="legal-form__column">
					<Field
						name="select"
						type="text"
						component={FormSelect}
						autoComplete="off"
						placeholder="Введите ИНН/ОГРН или название организации"
						icon="search"
						options={legalsOptions}
						loading={isLegalsLoading}
						noResultsMessage="Неизвестная организация"
						onSearchChange={onLegalSearchChange}
						onItemChange={onLegalChange}
						searchValue={legalsSearchValue}
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="legal-form__row">
				<Grid.Column width={5} />
				<Grid.Column width={8} className="legal-form__subtitle">
					Вы можете заполнить реквизиты вручную или выбрать из справочника.
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="legal-form__row">
				<Grid.Column width={5} className="legal-form__column">
					Название организации
				</Grid.Column>
				<Grid.Column width={8} className="legal-form__column">
					<Field
						name="name"
						type="text"
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите название организации"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="legal-form__row">
				<Grid.Column width={5} className="legal-form__column">
					ИНН
				</Grid.Column>
				<Grid.Column width={8} className="legal-form__column">
					<Field
						name="inn"
						type="text"
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите ИНН"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="legal-form__row">
				<Grid.Column width={5} className="legal-form__column">
					ОГРН
				</Grid.Column>
				<Grid.Column width={8} className="legal-form__column">
					<Field
						name="ogrn"
						type="text"
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите ОГРН"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="legal-form__row">
				<Grid.Column width={5} className="legal-form__column">
					Юридический адрес организации
				</Grid.Column>
				<Grid.Column width={8} className="legal-form__column">
					<Field
						name="address"
						type="text"
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите юридический адрес огранизации"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="legal-form__row legal-form__row-title">
				<Grid.Column width={16}>
					<h3 className="legal-form__second-title">Контактное лицо</h3>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="legal-form__row">
				<Grid.Column width={5} className="legal-form__column">
					Фамилия
				</Grid.Column>
				<Grid.Column width={8} className="legal-form__column">
					<Field
						name="contact.last_name"
						type="text"
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите фамилию"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="legal-form__row">
				<Grid.Column width={5} className="legal-form__column">
					Имя
				</Grid.Column>
				<Grid.Column width={8} className="legal-form__column">
					<Field
						name="contact.first_name"
						type="text"
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите имя"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="legal-form__row">
				<Grid.Column width={5} className="legal-form__column">
					Отчество
				</Grid.Column>
				<Grid.Column width={8} className="legal-form__column">
					<Field
						name="contact.middle_name"
						type="text"
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите отчество"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="legal-form__row">
				<Grid.Column width={5} className="legal-form__column">
					Почта
				</Grid.Column>
				<Grid.Column width={8} className="legal-form__column">
					<Field
						name="contact.email"
						type="text"
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите адрес электронной почты"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="legal-form__row">
				<Grid.Column width={5} className="legal-form__column">
					Телефон
				</Grid.Column>
				<Grid.Column width={8} className="legal-form__column">
					<FormDoublePhoneField
						mainFieldName="contact.phone"
						additionalFieldName="contact.extension"
						mainPlaceholder="+7 (___) ___-__-__"
						additionalPlaceholder="Добавочный"
						mainNormalize={normalizePhone}
					/>
				</Grid.Column>
			</Grid.Row>
		</Grid>
	);
};

LegalFormView.propTypes = {
	legalsOptions: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string.isRequired,
			value: PropTypes.string.isRequired,
			text: PropTypes.string,
			data: PropTypes.shape({
				title: PropTypes.string.isRequired,
				address: PropTypes.string.isRequired,
				deleted: PropTypes.bool,
			}),
		}),
	).isRequired,
	isLegalsLoading: PropTypes.bool.isRequired,
	onLegalSearchChange: PropTypes.func.isRequired,
	onLegalChange: PropTypes.func.isRequired,
	legalsSearchValue: PropTypes.string.isRequired,
	isLegalInfoLoading: PropTypes.bool.isRequired,
};
